<template>
  <div id="quickContact">
    <div v-if="dialogVisible" class="tool-booking">
      <div class="tool-booking-order">
        <div class="title">
          {{ dataForm.title }}
        </div>
        <div class="subtitle">
          <div class="subtitle-left">
            <div class="header-tags">
              <i class="el-icon-time"></i>
              <span
                >{{ dataForm.day ? dataForm.day : "-" }}天{{
                  dataForm.night ? dataForm.night : "-"
                }}晚</span
              >
              <i class="el-icon-s-custom"></i>
              <span
                >{{ dataForm.numberMin ? dataForm.numberMin : 0 }}-{{
                  dataForm.numberMax ? dataForm.numberMax : "不限"
                }}人</span
              >
            </div>
          </div>
          <div class="subtitle-right">
            <div class="price">{{ dataForm.price }}</div>
            <div class="avg-pirce">{{ dataForm.avgPrice }}人均价</div>
          </div>
        </div>
        <div class="element-row" style="height: 54px">
          <div class="element-col" style="height: 54px; padding-right: 55px">
            <span class="txt">出行人数</span>
            <el-select v-model="form.peopleNumber" placeholder="出行人数">
              <el-option
                v-for="(item, index) in getRequirementType.travelNumberType"
                :key="index"
                :label="item.name"
                :value="item.name"
              >
              </el-option>
            </el-select>
          </div>
          <div class="element-col" style="height: 54px; padding-left: 5px">
            <span class="txt">人均预算</span>
            <el-select v-model="form.avgPrice" placeholder="人均预算">
              <el-option
                v-for="(item, index) in getRequirementType.avgBudgetType"
                :key="index"
                :label="item.name"
                :value="item.name"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="element-row" style="height: 54px">
          <div class="element-col" style="height: 54px; padding-right: 70px">
            <span class="txt">团建天数</span>
            <el-select v-model="form.activityDay" placeholder="团建天数">
              <el-option
                v-for="(item, index) in getRequirementType.dayType"
                :key="index"
                :label="item.name"
                :value="item.name"
              >
              </el-option>
            </el-select>
          </div>
          <div class="element-col" style="height: 54px; padding-left: 5px">
            <span class="txt">联系人</span>
            <el-input
              v-model="form.contact"
              placeholder="联系人"
              style="display: inline"
            ></el-input>
          </div>
        </div>
        <div class="element-row" style="height: 54px">
          <div
            class="element-col"
            style="height: 54px; padding-right: 40px; box-sizing: border-box"
          >
            <span class="txt request">联系电话</span>
            <el-input
              v-model="form.mobile"
              placeholder="联系电话"
              style="display: inline"
            ></el-input>
          </div>
          <div
            class="element-col"
            style="height: 54px; padding-left: 29px; padding-right: 8px"
          >
            <span class="txt request">验证码</span>
            <div class="sendCode">
              <el-input
                v-model="form.verificationCode"
                placeholder="4位验证码"
                style="display: inline"
              ></el-input>
              <span
                class="txt2"
                :class="isPhoneNumber(form.mobile) ? 'active-txt2' : ''"
                @click="sendSMS"
                >{{ smsCodeTime != 0 ? smsCodeTime : "短信验证" }}</span
              >
            </div>
          </div>
        </div>
        <div class="element-row" style="height: 54px">
          <div
            class="element-col-simple"
            style="height: 54px; margin-right: 48%"
          >
            <span class="txt">微信号</span>
            <el-input
              v-model="form.wxNo"
              placeholder="微信号"
              style="display: inline"
            ></el-input>
          </div>
        </div>
        <div class="element-row" style="height: 54px">
          <div class="element-col" style="height: 54px; margin-left: 5%">
            <span class="txt">备注</span>
            <div class="inner-textarea">
              <el-input
                type="textarea"
                v-model="form.description"
                placeholder="非必填 如有特殊需求请填写备注告诉我们～"
              ></el-input>
            </div>
          </div>
        </div>
        <div class="element-row">
          <div class="element-col element-col-span-8">
            <div
              class="tool-button tool-booking-order-submit tool-button-primary"
            >
              <button class="" @click="submit">提交团建需求</button>
            </div>
          </div>
        </div>
        <div class="element-row">
          <div class="element-col">
            <img src="../../assets/process.png" alt="" />
          </div>
        </div>
        <span
          class="tool-booking-order-close"
          @click="closeRequireDialogVisible"
          >×</span
        >
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
import {isPhoneNumber} from "../../util/util";
export default {
  name: "quickContact",
  data() {
    return {
      scrollTop: 0,
      visible: false,
      visibletime: false,
      onlineDialog: false,
      smsCodeTime: 0,
      // 提交表单
      form: {
        peopleNumber: null,
        avgPrice: null,
        activityDay: null,
        contact: null,
        mobile: "",
        verificationCode: "",
        wxNo: null,
        description: null,
      },
      timer:"",
    };
  },
  props: {
    dialogVisible: false,
    dataForm: "",
  },
  components: {
    qs,
    
  },
  computed: {
    getRequirementType() {
      return this.$store.state.requirementTypeData;
    },
  },
  methods: {
    isPhoneNumber,
    clearForm(){
      // 提交表单
      this.form = {
        peopleNumber: null,
        avgPrice: null,
        activityDay: null,
        contact: null,
        mobile: "",
        verificationCode: "",
        wxNo: null,
        description: null,
      }
    },
    closeRequireDialogVisible() {
      this.$props.dialogVisible = false;
      this.clearForm();
      this.$emit("getRequireDialogVisible", false);
    },

    // 发送短信
    sendSMS() {
      if(this.smsCodeTime>0 || !isPhoneNumber(this.form.mobile)){
        return;
      }
      let params = { mobile: this.form.mobile };
      axios
        .get(`/api/verificationCode/sendCode`, {
          params,
        })
        .then((res) => {
          if (res.data) {
            if (res.data.code == 200) {
              // 成功则重置短信验证码时间
              this.smsCodeTime = 60;
              this.smsDown();
            } else {
              if (res.data.code == 500) {
                let msg = "";
                if (res.data.msg) {
                  msg = res.data.msg;
                } else {
                  msg = "短信发送失败";
                }
                this.$message({
                  message: msg,
                  type: "warning",
                  duration: 1500,
                  center: true,
                });
              }
            }
          }
        });
    },
    // 短信计时器
    smsDown() {
      this.timer = setInterval(() => {
        if (this.smsCodeTime != 0) {
          this.smsCodeTime = this.smsCodeTime - 1;
        }
      }, 1000);
    },
    // 提交表单
    submit() {
      let { mobile, verificationCode } = this.form;
      console.log(!mobile || mobile.length != 11);
      console.log(!verificationCode);
      if (!mobile || mobile.length != 11) {
        this.$message({
          message: "请正确填写手机号码",
          type: "warning",
          duration: 1500,
          center: true,
        });
        return;
      }
      if (!verificationCode) {
        this.$message({
          message: "请正确填写验证码",
          type: "warning",
          duration: 1500,
          center: true,
        });
        return;
      }
      // this.form = {
      //   mobile,
      //   verificationCode,
      // };
      this.form.type = "1";
      this.form.tbId = this.dataForm.id;
      this.form.title = this.dataForm.title;
      let params = this.form;
      // let params = {
      //   peopleNumber: "",
      //   avgBudget: "",
      //   teamBuildingDay: "",
      //   contact: "",
      //   mobile: "",
      //   verificationCode: "",
      //   wxNo: "",
      //   description: "",
      // };
      axios
        .post(`/api/requirement/submit`, JSON.stringify(params), {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
          },
        })
        .then((res) => {
          console.log(res);
          let msg = "";
          if (res.data) {
            if (res.data.code == 200) {
               if (res.data.msg) {
                  msg = res.data.msg;
                } else {
                  msg = "需求提交成功";
                }
                this.$message({
                  message: msg,
                  type: "success",
                  center: true,
                });
                this.closeRequireDialogVisible();
            } else {
              if (res.data.code == 500) {
                
                if (res.data.msg) {
                  msg = res.data.msg;
                } else {
                  msg = "需求提交失败";
                }
                this.$message({
                  message: msg,
                  type: "error",
                  duration: 1500,
                  center: true,
                });
              }
            }
          }
        });
    },
  },
  mounted() {},
  destroyed() {},

  // 为了计算距离顶部的高度，当高度大于60显示回顶部图标，小于60则隐藏
  scrollToTop() {
    const that = this;
    let scrollTop =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop;
    that.scrollTop = scrollTop;
    if (that.scrollTop > 120) {
      that.btnFlag = true;
    } else {
      that.btnFlag = false;
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this tool only -->
<style scoped>
</style>
<style>
.iconfont {
  font-family: iconfont !important;
  font-size: 14px;
  font-style: normal;
  text-align: center;

  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.tool-booking {
  background: rgba(0, 0, 0, 0.4);
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  position: fixed;
  z-index: 1001;
}
.tool-booking-order {
  position: absolute;
  top: 50%;
  left: 50%;
  background: #fff;
  border-radius: 14px;
  width: 616px;
  margin-top: -263px;
  margin-left: -308px;
  padding: 25px 51px;
}

.request::before {
  content: "*";
  color: red;
  position: relative;
}
.element-row,
.element-row:after,
.element-row:before {
  display: flex;
  justify-content: center;
}
.element-row {
  flex-flow: row wrap;
}
.tool-booking .tool-booking-order .tool-booking-order-close {
  display: block;
  width: 60px;
  height: 60px;
  position: absolute;
  top: 0;
  right: 0;
  line-height: 60px;
  text-align: center;
  font-size: 30px;
  cursor: pointer;
  border-radius: 0 14px 0 0;
  transition: all 0.2s ease-in-out;
}
.element-col-span-12 {
  display: block;
  flex: 0 0 50%;
  max-width: 50%;
}
.element-col {
  position: relative;
  max-width: 100%;
  min-height: 1px;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
}
.element-col-simple {
  position: relative;
  max-width: 100%;
  min-height: 1px;
  display: flex;
  flex-wrap: nowrap;
  justify-items: flex-start;
  align-items: center;
}
.element-col-canwrap {
  position: relative;
  max-width: 100%;
  min-height: 1px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.tool-booking .tool-booking-order .tool-booking-order-submit {
  margin-top: 60px;
}
.tool-button-primary {
  background: #222;
}
.sendCode {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  border: none;
  background: #f8f8f8;
  border-radius: 6px;
}
.tool-booking .sendCode .el-input__inner {
  border: none;
  border-color: transparent;
  background: fixed;
  width: 100px !important;
  margin-top: 0px !important;
}
.sendCode span {
  flex-shrink: 0;
  display: inline-block;
  font-size: 14px;
  text-align: center;
  color: rgba(23, 211, 161, 0.2);
  cursor: pointer;
  width: 80px;
}
.sendCode .active-txt2 {
  flex-shrink: 0;
  display: inline-block;
  font-size: 14px;
  text-align: center;
  color: rgba(23, 211, 161);
  cursor: pointer;
  width: 80px;
}
.tool-button {
  width: 100%;
  position: relative;
  font-weight: 700;
  font-size: 16px;
  color: #fff;
  letter-spacing: 1.6px;
  text-align: center;
  border-radius: 2px;
  height: 44px;
}
.element-col-push-8 {
  left: 33.33333333%;
}
.element-col-span-8 {
  display: block;
  flex: 0 0 33.33333333%;
  max-width: 33.33333333%;
}
/* el-select 样式 */
.tool-booking .el-input__inner {
  /* border: none; 
    border-color: transparent ;
    
    color:#000;
    font-weight: 700; */
  background: #f8f8f8;
  border: none;
  width: 180px !important;
}
.el-select-dropdown__item {
  /* height: 45px !important;
    font-size: 20px !important;
    line-height: 45px; */
}
.el-select-dropdown__list .selected {
  /* height: 45px !important;
    font-size: 20px !important;
    line-height: 45px; */
  color: #606266 !important;
}
.tool-booking .el-select-dropdown__item:hover {
  /* height: 45px !important;
    font-size: 20px !important;
    line-height: 45px; */
  background: #f8f8f8;
}

.tool-booking.el-input {
  display: inline !important;
}
.tool-booking .el-input input {
  display: block;
}
.tool-booking-order .txt {
  padding-right: 5px;
  display: block;
  width: 100%;
}
.txt1 {
  width: auto !important;
  padding-bottom: 5px;
}
.tool-booking .el-textarea__inner {
  background: #f8f8f8;
  width: 490px;
  border: none;
  min-height: 100px !important;
}

.tool-booking .inner-textarea {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 60px;
}

.tool-button-primary button {
  color: #fff;
  font-weight: 700;
}
.tool-button button {
  outline: none;
  background: none;
  border: none;
  width: 100%;
  height: 100%;
  cursor: pointer;
}
.element-col img {
  margin-top: 30px;
  width: 600px;
}
.tool-booking-order .title {
  font-weight: 700;
  font-size: 20px;
  color: #222;
}
.tool-booking-order .subtitle {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-content: space-between;
}
.tool-booking-order .subtitle .subtitle-left {
}
.subtitle-left .header-tags {
  margin-top: 10px;
}
.subtitle-left .header-tags span {
  font-weight: 700;
  font-size: 14px;
  color: #222;
  line-height: 33px;
  height: 33px;
}
.tool-booking-order .subtitle .subtitle-right {
}
.tool-booking-order .subtitle .subtitle-right .price {
  font-weight: 700;
  font-size: 20px;
  color: #fa5821;
  text-align: left;
  margin-top: 14px;
  text-align: right;
}
.tool-booking-order .subtitle .subtitle-right .price::after {
  content: "元起/人";
  font-weight: 700;
  font-size: 12px;
  color: #666;
  text-align: left;
  line-height: 28px;
}
.tool-booking-order .subtitle .subtitle-right .avg-pirce {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/comment/rquirementsForm.vue